import { Grid } from '@material-ui/core';
import React from 'react'
import truck from '../images/truck2.png';

type SelectedIdAndType = {
    id: string;
    type: string;
}

type props = {
    elementId: string;
    description: string;
    total: string;
    old: string;
    type: string;
    selectedIdAndType: SelectedIdAndType;
    onClick?: () => void,
};


const ShedMonitor: React.FC<props> = ({ onClick, elementId, description, total, old, type, selectedIdAndType  }) => {

    return (
    
    <Grid item style={{
        borderWidth: '1px', 
        borderColor: selectedIdAndType.id === elementId && selectedIdAndType.type === type  ? 'rgba(210,105,30, 1)' : 'rgba(65,105,225, 0.5)', 
        borderStyle: 'solid',
        fontSize: 16,
        margin: 3,
        width: '48%',
        cursor: 'pointer',
    }}>
        <div onClick={onClick} style={{
            display: 'flex',
            flexDirection: 'column'
        }}>

            <div style={{
                color: 'rgba(255, 255, 255, 1)',
                fontWeight: 'bold',
                backgroundColor: selectedIdAndType.id === elementId && selectedIdAndType.type === type ? 'rgba(210,105,30, 1)' : 'rgba(65,105,225, 0.5)',
                textAlign: 'center',
            }}>{description}</div>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: 8,
            }}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                    <strong>Total</strong>
                    <div style={{
                        width: 36,
                        height: 36,
                        borderRadius: 18,
                        borderWidth: 1,
                        borderStyle: 'solid',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>{total}</div>
                </div>
                <div><img src={truck} width={54} height={54} style={{}}/></div>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                    <strong>Old</strong>
                    <div style={{
                        width: 36,
                        height: 36,
                        borderRadius: 18,
                        borderWidth: 1,
                        borderStyle: 'solid',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: old == '0' ? 'rgba(50,205,50, 1)' :'rgba(178,34,34,1)',
                        color: 'rgba(255, 255, 255, 1)',
                    }}>{old}</div>
                </div>
            </div>
        </div>
    </Grid>
  )
}

export default ShedMonitor;